export const getMediaUrl = (media) => {
  if (media && media.url) {
    let url = media.url

    // Add timestamp if media isn't blobbed and if it doesn't have a previous timestamp.
    if (!url.startsWith('blob') && !url.includes('?_=')) {
      url += '?_=' + (media.timestamp || Date.now())
    }
    return url
  }

  if (media && typeof media === 'object') {
    let url = URL.createObjectURL(media)
    if (!url.startsWith('blob')) {
      url += '?_=' + Date.now()
    }
    return url
  }
  return media
}

const readFileBytes = (file) => {
  if (typeof file.arrayBuffer === 'function') {
    return file.arrayBuffer();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Copy dropped files' bytes into new in-memory Files.
 *
 * iPad Safari backs drag-and-dropped Files with temporary blobs that WebKit
 * can release before the upload request body is serialized. When that happens
 * the request is sent with an empty body (Content-Length: 0) and no form
 * fields reach the API (ID360-934). Snapshotting the bytes at drop time
 * removes the dependency on the original blob surviving until upload.
 *
 * Files whose backing blob is already unreadable are skipped.
 */
export const snapshotFiles = async (files) => {
  const snapshots = [];

  for (const file of files) {
    try {
      const buffer = await readFileBytes(file);
      snapshots.push(new File([buffer], file.name, { type: file.type, lastModified: file.lastModified }));
    } catch (error) {
      console.error(`MultipleMediaUpload: could not read dropped file "${file.name}"`, error);
    }
  }

  return snapshots;
};

export const getRandomNumber = () => {
  let randomHashArray;

  if (typeof window === 'object' && window.crypto) {
    randomHashArray = new Uint32Array(1);
    window.crypto.getRandomValues(randomHashArray);
  } else {
    randomHashArray.push(Math.random() * 2097152);
  }

  return randomHashArray[0];
}
